import basic from  './basic'
import service from  './service'
// import module from  './module'

const ru = {
  ...basic,
  ...service,
  // ...module,
}

export default ru
